import { useMutationWithRefresh } from '../useMutationWithRefresh';
import simService from '../../services/simService';
import { queryKeys } from '../../queryClient';

// สร้าง SIM
export const useCreateSim = (options?: { skipSuccessMessage?: boolean }) => {
  return useMutationWithRefresh({
    mutationFn: (data: any) => simService.createSim(data),
    invalidateKeys: [
      queryKeys.sims.all,
      queryKeys.devices.all, // devices อาจแสดง dropdown SIM
      queryKeys.rentals.all,
    ],
    successMessage: options?.skipSuccessMessage ? undefined : 'สร้าง SIM สำเร็จ',
  });
};

// แก้ไข SIM
export const useUpdateSim = () => {
  return useMutationWithRefresh({
    // BUG-S162-P1 rollout (S410): forward last-seen updated_at as ifMatch → stale write gets 409
    mutationFn: ({ id, data, ifMatch }: { id: number; data: any; ifMatch?: string }) => 
      simService.updateSim(id, data, ifMatch),
    invalidateKeys: [
      queryKeys.sims.all,
      queryKeys.devices.all, // devices แสดงข้อมูล SIM
      queryKeys.rentals.all,
    ],
    successMessage: 'แก้ไข SIM สำเร็จ',
  });
};

// ลบ SIM
export const useDeleteSim = () => {
  return useMutationWithRefresh({
    mutationFn: (id: number) => simService.deleteSim(id),
    invalidateKeys: [
      queryKeys.sims.all,
      queryKeys.dashboard.summary,
    ],
    successMessage: 'ลบ SIM สำเร็จ',
  });
};